"use client";

import { useEffect, useState, useRef } from "react";
import io, { Socket } from "socket.io-client";

const SERVER_URLS = {
    PROD: "https://falcon.api.probo.in",
    STAGE: "https://falcon-default.stg.probolabs.com",
    PRE_PROD: "ws://pre-prd.falcon.api.probo.in",
    LOCAL: "ws://localhost:9001",
};

const useWebSocketScorecard = (
    server: keyof typeof SERVER_URLS = "PROD",
    topicId,
) => {
    const [scorecardData, setScorecardData] = useState({});
    const socketRef = useRef<Socket | null>(null);

    const TOPIC = `SI_${topicId}_CRICKET`;

    useEffect(() => {
        if (!topicId) return;

        // If a WebSocket connection already exists, reuse it
        if (!socketRef.current) {
            socketRef.current = io(SERVER_URLS[server], {
                transports: ["websocket"],
            });

            const socket = socketRef.current;

            socket.on("connect", () => {
                console.log("Connected to WebSocket");
                socket.emit("echo");
                socket.emit("subscribe_scorecard", TOPIC);
            });

            socket.on(`scorecard_data_${TOPIC}`, (data) => {
                setScorecardData(data);
            });

            socket.on("connect_error", (err) => {
                console.error("Connection error:", err);
            });

            socket.on("disconnect", () => {
                console.log("Disconnected from WebSocket");
                socketRef.current = null; // Reset on disconnect
            });
        }

        return () => {
            if (socketRef.current) {
                socketRef.current.disconnect();
                socketRef.current = null;
            }
        };
    }, [server, topicId]);

    return scorecardData;
};

export default useWebSocketScorecard;
